import React, { useState, useContext, useEffect } from "react";
import { Container, Row, Col, Form, Alert } from "react-bootstrap";
import GlobalContext from "../../GlobalContext";
import { useMyContext } from "../../MyContext";
import { Box, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import Editor from "react-simple-wysiwyg";
import { FaChevronLeft } from "react-icons/fa6";
//Components
import TopMargin from "../TopMargin";
import RowMargin from "../RowMargin";
import SuperAppButton from "../SuperAppButton";
import List from "../List";
import Object from "../Object"; /* KAD added this for Integrations feature 2/22/2025 */
import DrawMenu from "../DrawMenu";
import PopupGallery from "../PopupGallery";
import Loading from "../Loading";
import Options from "../Options";
import PopoverPicker from "../PopoverPicker/PopoverPicker";
import UploadFile from "../UploadFile";
import {
  evaluateDynamicLogic,
  evaluateCondition /* capitalize */,
} from "./utils";
import "../../pages/Home.css";
import { v4 as uuid } from "uuid";
import { fetchSecure } from "./utils";
import { convertCamelToDisplayName } from "../../utils/utils";
import SecureImage from "../SecureImage";
import DynamicJsonEditorV2 from "../DynamicJsonEditorV2";
import DynamicJsonEditorV1 from "../integration_components/DynamicJsonEditorV1";
import { useDataCache } from "../../DataCacheContext";
import MCPClientUI from "../../pages/mcp-gateway";

import IntegrationEditorConfig from "../integration_components/IntegrationEditorConfig";
import MultiSelect from "../MultiSelection";
import TextareaList from "../TextArealist";
import MultiHtmlContent from "../multiHtmlContent";

export default function CreateEditNew(props) {
  const superAppStyle = useContext(GlobalContext)["superAppStyle"];
  const globalContextData = useMyContext();
  const { dataCache, setDataCache } = useDataCache(); // Access dataCache
  const [validated, setValidated] =
    useState(false); /* for Bootstrap form validation */
  const [validationString, setValidationString] =
    useState(
      ""
    ); /* KAD put this in April 11, 2022 because people weren't entering all the required fields and Typeahead required NOT working like Form Controls */
  const [originalData /* setOriginalData */] = useState(props.originalData);
  const [actionType, setActionType] = useState(props.actionType);
  const [formData, setFormData] = useState({
    data: props.thisObject,
    status: "IDLE",
  });
  // console.log("🚀 ~ CreateEditNew ~ formData:", formData)
  // console.log("🚀 ~ CreateEditNew ~ props.formData:", formData.data);
  const myObjectsLookup =
    {}; /* KAD added Jan 18, 2025 for the Test Plans Feature */
  const debug = globalContextData["data"]["debugOn"];

  const isInvalidColor = (strColor) => {
    if (typeof strColor === "undefined") return true;
    const s = new Option().style;
    s.color = strColor;
    if (debug)
      console.log("checking color for " + strColor + "," + (s.color === ""));
    return s.color === "";
  };

  /* KAD added August 19, 2025 to deal with website https/http error we wanted to prevent */
  function validateRegex(value, patternString) {
    // Use a try...catch block to handle potential errors with invalid regex patterns.
    try {
      if (typeof value !== "string") {
        //console.warn("Warning: The provided value is not a string. (" + value + "), just pass it");
        return true;
      }
      const pattern = new RegExp(patternString);
      // The test() method executes a search for a match between a regular expression
      // and a specified string. It returns true or false.
      return pattern.test(value);
    } catch (error) {
      console.error("Error: An invalid regex pattern was provided.");
      console.error(error.message);
      return false;
    }
  }

  /* creates the Red Text under the field if a validation fails */
  const isInvalidField = (str, field) => {
    field.error_message = "";
    //if (debug) console.log("in isInvalidField - " + JSON.stringify(field));
    if (typeof field.max_length === "string") {
      const values = field.max_length.split(".");
      // const tryNext = false;
      if (values[0] === "users") {
        if (values[1] in props.userDeep) {
          if (debug) console.log("in userdeep");
          field.max_length = props.userDeep[values[1]];
        } else values[0] = "adminConfig"; // check for a value higher up the hierarchy..did this because variable might not be set for 1000 users when a new config is set but putting at adminConfig or ENVIRONMENT is relatively easy as a catch all
      }
      if (values[0] === "adminConfig") {
        if (values[1] in globalContextData["data"]) {
          field.max_length = globalContextData["data"][values[1]];
          if (debug) console.log("in adminConfig");
        } else values[0] = "env"; // check for a value higher up the hierarchy..did this because variable might not be set for 1000 users when a new config is set but putting at adminConfig or ENVIRONMENT is relatively easy as a catch all
      }
      if (values[0] === "env") {
        if (values[1] in process.env[values[1]])
          field.max_length = process.env[values[1]];
      }
    }

    if (Number.isInteger(field.max_length)) {
      field.max_length = Number(field.max_length);
    }

    if (field.max_length && str && str.length > field.max_length) {
      field.error_message =
        "Field too long (max " + field.max_length + " chars)";
      return true;
    }

    if (field.regex) {
      /* KAD added Aug 19, 2025 */
      if (!validateRegex(str, field.regex)) {
        field.error_message = field.possible_error_message;
        return true;
      }
    }

    if (!Number.isInteger(str)) {
      str = Number(str);
    }
    if (field.validate_number && !Number.isInteger(str)) {
      field.error_message = "Field should be a valid integer";
      return true;
    }

    return false;
  };

  /* Have to keep this logic consistent with a copy in CreateEdit, TODO: move to a shared library  */
  function canDeleteRow(props, config, rowData) {
    if ("locked" in rowData && rowData["locked"] === true) return false;

    if (
      props.userDeep &&
      props.userDeep.roles &&
      props.userDeep.roles.toLowerCase().indexOf("delete") >= 0
    )
      return true;

    if (
      config.security &&
      config.security.delete &&
      config.security.delete.indexOf("AllUsers") >= 0
    )
      return true;

    if (
      config.security &&
      config.security.delete &&
      config.security.delete.indexOf("createdBy") >= 0 &&
      props.user &&
      rowData.user &&
      props.user === rowData.createdBy
    )
      return true;

    return false;
  }

  /* This code makes n columns of data...someday n will be configurable */
  const arrayChunk = (arr, n) => {
    //const array = arr.slice();
    var colCounter = 0;
    var colArray = [];
    var rowArray = [];
    for (let x = 0; x < arr.length; x++) {
      var element = arr[x];
      if (element.input_type === "none") {
        x++;
        element = arr[x];
      }

      var colspan = 1;
      if ("colspan" in element) {
        colspan = element["colspan"];
        if (colspan === 3) colCounter = n - 1;
        if (colspan + colCounter >= n) {
          colCounter = n - 1;
        }
      }
      colArray.push(element);
      colCounter++;
      if (colCounter === n) {
        rowArray.push(colArray);
        colArray = [];
        colCounter = 0;
      }
    }
    /* KAD added this Sept 16, 2024 */
    if (colCounter !== 0) {
      rowArray.push(colArray);
    }
    return rowArray;
  };
  const onColorChange = (value, name) => {
    if (debug) console.log("onColorChange " + name + "," + value);
    setFormData({
      data: { ...formData.data, [name]: value },
      status: "IDLE",
    });
  };
  const handleInputChange = (e) => {
    const target = e.currentTarget;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    /* NEW */
    var updatedFormData = { ...formData.data, [name]: value };
    if (target.type === "select-one" && name === "agentId") {
      const name1 = "agentName";
      const value1 = myObjectsLookup[value][name1];
      updatedFormData = { ...updatedFormData, [name1]: value1 };
      //console.log("IN HERE - " + JSON.stringify(updatedFormData));
    }
    /* NEW */
    if (false) {
      setFormData({
        data: { ...formData.data, [name]: value },
        status: "IDLE",
      });
    } else {
      setFormData({
        data: { ...updatedFormData },
        status: "IDLE",
      });
    }
  };
  const onHTMLChange = (e, name) => {
    setFormData({
      data: { ...formData.data, [name]: e.target.value },
      status: "IDLE",
    });
  };
  const formInvalid = () => {
    var invalid = false;
    var fieldString = "";
    var otherErrors = "";
    // eslint-disable-next-line array-callback-return
    var currentTab = ""; // KAD added Mar 22, 2025 to try and not validate required fields for one tab
    var validateTab = true;
    props.config.fields.map((field) => {
      var showField = true;
      if (typeof field.header !== "undefined" && field.type === "tab") {
        /* KAD added Mar 22, 2025 */
        currentTab = field.header;
        if (typeof field.dontValidateTab !== "undefined") {
          validateTab = false;
        } else {
          validateTab = true;
        }
      }

      if (typeof field.conditional !== "undefined") {
        //     conditional: "AGENT_TYPE === DIALOGFLOW",
        /* Need to finish this code to handle more logic */
        if (false) {
          const values = field.conditional.split(" ");
          const key = values[0];
          // const operator = values[1];
          const value = values[2];
          if (formData.data[key] !== value) showField = false;
        } else {
          /* KAD added April 8, 2025 */
          if (!evaluateCondition(field, formData)) {
            showField = false; // Or null, or whatever you want to return
          }
        }
      }
      /* Not sure if this validation logic works. Really about if I need showField to be true or false..Think it has to be required for it to matter  */
      if (typeof field.conditional1 !== "undefined") {
        //     conditional: "AGENT_TYPE === DIALOGFLOW",
        /* Need to finish this code to handle more logic */
        var variables = formData.data;
        variables["users"] = props.userDeep;
        variables["users_roles"] =
          props.userDeep[
            "roles"
          ]; /* KAD added April 21, 2025 to search for matching roles to show a field */
        variables["admins"] = [];

        /* KAD added this Jan 15, 2025 to pull admins from the new field adminEmails */
        if (Array.isArray(globalContextData["data"]["adminEmails"])) {
          variables["admins"] = [
            ...globalContextData["data"]["adminEmails"],
          ]; /* Added admin emails of context data into admins varible. Vik, Feb 11, 2025 */
        }
        showField = evaluateDynamicLogic(field.conditional1, variables);
        delete formData.data["users"];
        delete formData.data["admins"];
        delete formData.data["users_roles"];
      }
      if (
        validateTab /* KAD added Mar 22, 2025 to make it configurable to NOT validate an entire tab */ &&
        field.required &&
        showField &&
        (!formData.data[field.name] || formData.data[field.name].length === 0)
      ) {
        if (debug) console.log("Form invalid - " + field.name);
        fieldString += field.display_name + ", ";
        invalid = true;
      }
      /* KAD added this Aug 19, 2025 to prevent form from being submitted if I have an error on it */
      if (isInvalidField(formData.data[field.name], field)) {
        if (debug)
          console.log(
            "Form invalid - " + field.name + "," + JSON.stringify(field)
          );
        invalid = true;
      }
    });
    if (invalid) {
      if (fieldString.length > 2)
        setValidationString(
          ", required fields missing: " +
            fieldString.substring(0, fieldString.length - 2) +
            otherErrors
        );
      return true;
    } else return false;
  };

  const handleSubmit = async (event) => {
    try {
      const form = event.currentTarget;
      /* this will cause the Loading text to show up while waiting */
      setFormData({
        ...formData,
        status: "SUBMITTED",
      });

      /* adding another custom level of validation for objects */
      let valid = true;
      if (typeof props.validateObject !== "undefined") {
        valid = props.validateObject(formData.data);
        if (debug) console.log("valid = " + JSON.stringify(valid));
        formData.data["status"] = valid.status;
      }
      if (formInvalid(formData) || form.checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();
        setValidated(true);
        setFormData({
          ...formData,
          status: "VALIDATION_FAILURE",
        });
      } else {
        setValidated(false);
        var dataToSave = {};
        /* if we are in a subtable..pass the new record up to higher level to save */
        if (props.depth > 0 && props.topLevelSave) {
          if (!("id" in formData.data)) {
            formData.data["id"] = uuid();
          }
          var found = false;
          for (let x = 0; x < props.inputData.length && !found; x++) {
            if (props.inputData[x]["id"] === formData.data["id"]) {
              found = true;
              props.inputData[x] = formData.data;
            }
          }
          if (!found) {
            props.inputData.push(formData.data);
          }
          props.topLevelSave(
            "testPlan",
            props.inputData
          ); /* KAD FIX TODO..April 23, 2025 not sure why this has testPlan hardcoded */
          return;
        }
        if ("row" in formData.data && typeof props.sub_array !== "undefined") {
          /* this is an existing row when a subarray is involved  */
          const row = formData.data["row"];
          if (debug) console.log("ROW in Submit = " + row);
          originalData[row][props.sub_array] = formData.data;
          if (debug) console.log(JSON.stringify(originalData[row]));
          dataToSave = originalData[row];
        } else if (
          !("row" in formData.data) &&
          typeof props.sub_array !== "undefined"
        ) {
          /* this is a new row when a subarray is involved */
          dataToSave[props.sub_array] = formData.data;
        } else {
          dataToSave = formData.data;
        }
        if (props.config.collection !== "users") {
          /* was seeing weird behavior editing the User table from System Admin screen...we can't overwrite the user if we are editing the users table Jan 17, 2025 */
          dataToSave["user"] =
            props.user; /* We now send the user record from the front end as of Aug 2, 2024 */
          // console.log(
          //   "Calling save func >>>>>.",
          //   props.config.collection,
          //   dataToSave
          // );
        }

        const response = await fetchSecure(
          "/api/saveObject/" + props.config.collection,
          {
            headers: { "Content-Type": "application/json" },
            method: "post",
            //ORIG JUL 15, 2024body: JSON.stringify(formData.data)
            body: JSON.stringify(dataToSave),
          }
        );
        const data = await response.json();
        if (data.success) {
          formData.data["id"] =
            data.id; /* KAD added this to populate the primary key in the UI after saving for the first time */
          if (debug) console.log(data);
          setFormData({
            data: { ...formData.data },
            status: "SUCCESS",
          });
          //props.setDisplayState("X"); /* KAD took this out Aug 19, 2024 */
          if (debug) console.log(JSON.stringify(formData));

          /* Go back and update the Tracking records */
          //setTimeout(() => { props.loadObject(data.id)}, 1000)

          /* Update dataCache for agents or integrations. Vik, APR 15, 2025 */
          if (
            props.config.collection === "agents" ||
            props.config.collection === "integrations"
          ) {
            if (debug) {
              console.log("dataCache :: Before updating dataCache:", dataCache);
            }
            const newItem = { ...formData.data };
            let updatedItems = [];
            let updatedItemsLookup = {};

            if (props.config.collection === "agents") {
              updatedItems = dataCache.agents ? [...dataCache.agents] : [];
              updatedItemsLookup = dataCache.agentsLookup
                ? { ...dataCache.agentsLookup }
                : {};
              const lookupEntry = {
                agentName: newItem.agentName,
                agentType: newItem.agentType,
              };

              if (actionType === "CREATE") {
                updatedItems.push(newItem);
                updatedItemsLookup[newItem.id] = lookupEntry;
              } else if (actionType === "EDIT") {
                const index = updatedItems.findIndex(
                  (item) => item.id === newItem.id
                );
                if (index !== -1) {
                  updatedItems[index] = newItem;
                  updatedItemsLookup[newItem.id] = lookupEntry;
                }
              }
              setDataCache({
                ...dataCache,
                agents: updatedItems,
                agentsLookup: updatedItemsLookup,
              });
            } else if (props.config.collection === "integrations") {
              updatedItems = dataCache.integrations
                ? [...dataCache.integrations]
                : [];
              updatedItemsLookup = dataCache.integrationsLookup
                ? { ...dataCache.integrationsLookup }
                : {};

              if (actionType === "CREATE") {
                updatedItems.push(newItem);
                updatedItemsLookup[newItem.id] = { ...newItem };
              } else if (actionType === "EDIT") {
                const index = updatedItems.findIndex(
                  (item) => item.id === newItem.id
                );
                if (index !== -1) {
                  updatedItems[index] = newItem;
                  updatedItemsLookup[newItem.id] = { ...newItem };
                }
              }
              setDataCache({
                ...dataCache,
                integrations: updatedItems,
                integrationsLookup: updatedItemsLookup,
              });
            }

            if (debug) {
              console.log("dataCache :: After updating dataCache:", {
                [props.config.collection]: updatedItems,
                [props.config.collection + "Lookup"]: updatedItemsLookup,
              });
            }
          }

          props.setFormData(formData);
          if (props.scrollToTop) props.scrollToTop();

          if (
            formData.data.agentType === "DOCUMENT_QA" &&
            actionType === "CREATE"
          ) {
            /* TODO: KAD added this Oct 5, 2024..need to generalize because can't be hardcoded */
            props.setDisplayState("UPLOAD_ATTACHMENT");
            //props.setActionType("UPLOAD");
          } else {
            if (
              formData.data.agentType === "WEBSITE_QA" &&
              actionType === "CREATE"
            )
              alert('Please now hit the "Scan Website" button');
            props.setDisplayState("DISPLAY");
            props.setActionType("DISPLAY");
          }
        } else {
          throw Error("Failed to add new " + props.config.name);
        }
      }
      /** Post processing for updating default faq prompt. Vik Feb 20, 2025 */
      if (props.submit) {
        await props.submit(event, props.config.collection, formData.data);
      }
    } catch (e) {
      console.log(
        `Failed to add new ` +
          props.config.name +
          `: ${formData.data.agentType}`
      );
      console.error(e);
      console.error(e.stack);
      setFormData({
        ...formData,
        status: "ERROR",
      });
    }
  };
  /* KAD added this in for ConfigEditor Feb 10, 2025 */
  const handleSubmitWithoutPersist = async (event) => {
    try {
      if (formInvalid()) {
        setFormData({
          ...formData,
          status: "VALIDATION_FAILURE",
        });
      } else {
        console.log("XXXX" + JSON.stringify(formData.data));
        /* KAD took out entire block for nested arrays in the data...since we don't really need that yet
           if ("id" in formData.data)
           {
              data[parseInt(formData.data["id"])] = formData.data;
           }
           else
           {
              if (data)
              {
                formData.data["id"] = (data.length) + "";
                data.push(formData.data);
              }
           }
           if (data) setData(data); * KAD added the if statement because it was crashing on the data.length because data was undefined *
*/
        setFormData({
          ...formData,
          status: "SUCCESS",
        });

        console.log("in savefields - " + props.config.collection_name);
        console.log("in savefields - " + JSON.stringify(formData));
        props.setFormData(formData);
        if (props.submit)
          props.submit(
            event,
            props.config.collection,
            formData
          ); /* this is for a map object */
        props.setDisplayState("DISPLAY");
        props.setActionType("DISPLAY");
        /* KAD took out to debug props.submit code...ddata and setData were originally in the same files as this one..but new verions NOT Feb 10, 2025  if (props.submitData) props.submitData(event, props.config.collection_name, data); /* this is for an array object */
      }
    } catch (e) {
      console.log(e);
      console.log("Failed to add new " + props.config.name);
      setFormData({
        ...formData,
        status: "ERROR",
      });
    }
  };

  const handleCancel = async () => {
    if (actionType === "CREATE")
      /* KAD Mar 17, 2025 added this because we need to do different things when hitting cancelled based on where we started */
      props.setDisplayState("TABLE");
    else props.setDisplayState("DISPLAY"); // KAD changed Dec 30 2024
  };

  const OLDevaluateDisplayDropdownRule = (displayRule) => {
    const displayRuleSplitArray = displayRule.split(" ");
    var key = "";
    if (displayRuleSplitArray[0] === "users.planName")
      key = props.userDeep["planName"];
    const operator = displayRuleSplitArray[1];
    const value = displayRuleSplitArray[2];
    if (operator === "==") {
      if (key === value) return true;
    }
    if (operator === "!=") {
      if (key !== value) return true;
    }
    return false;
  };
  const evaluateDisplayDropdownRule = (displayRule, userDeep) => {
    /* KAD added from AI April 8, 2025 to have a more powerful language */
    const displayRuleSplitArray = displayRule.split(" ");
    let key = "";
    let operator = "";
    let value = "";

    // Handle OR statements
    if (displayRule.includes("||")) {
      const orConditions = displayRule.split("||");
      for (const condition of orConditions) {
        if (evaluateSingleCondition(condition.trim(), userDeep)) {
          return true;
        }
      }
      return false;
    } else {
      return evaluateSingleCondition(displayRule, userDeep);
    }
  };

  const evaluateSingleCondition = (singleCondition, userDeep) => {
    const conditionSplitArray = singleCondition.split(" ");
    const keyPath = conditionSplitArray[0];
    const operator = conditionSplitArray[1];
    const value = conditionSplitArray[2];

    // Dynamically access nested properties
    let keyValue = userDeep;
    const pathParts = keyPath.split(".");
    if (pathParts.length === 2) {
      if (keyValue && keyValue.hasOwnProperty(pathParts[1])) {
        keyValue = keyValue[pathParts[1]];
      } else {
        // Key not found, condition fails
        return false;
      }
    }

    // Handle different operators
    if (operator === "==") {
      return keyValue === value;
    } else if (operator === "!=") {
      return keyValue !== value;
    } else if (operator === ">") {
      return keyValue > value;
    } else if (operator === "<") {
      return keyValue < value;
    } else if (operator === ">=") {
      return keyValue >= value;
    } else if (operator === "<=") {
      return keyValue <= value;
    } else if (operator === "includes") {
      return String(keyValue).includes(value);
    } else {
      // Unsupported operator, condition fails
      return false;
    }
  };

  const setListData = (fieldName, newList) => {
    // (MK) 04/10/25 Force update
    setFormData((prev) => {
      return {
        data: { ...prev.data, [fieldName]: newList },
        status: "IDLE",
      };
    });
  };

  useEffect(() => {
    if (props) {
      let tabs = arrayChunkNew(props.config.fields, 3);
      let activeTab = props.activeTab || 0;
      tabs[activeTab].rows.map((row, rowIndex) => {
        row?.map((field, colIndex) => {
          // console.log("🚀 ~ row?.map ~ field:", field?.textConditional)

          if (field?.textCondition) {
            const condition = field.textCondition;
            const value = getValueFromCondition(
              condition,
              formData?.data,
              field
            );
            // console.log("🚀 ~ row?.map ~ value:", value, condition);
            if (value) {
              setFormData((prev) => {
                return {
                  data: { ...prev.data, [field.name]: value?.tool_description },
                  status: "IDLE",
                };
              });
            }
          }
        });
      });
    }
  }, [formData.data?.sample_template]);

  // (MK) This function is used to evaluate the condition of a field and return the value if the condition is met.
  function getValueFromCondition(condition, formData, field) {
    if (!condition.includes("==")) return undefined;

    const [leftRaw, rightRaw] = condition.split("==").map((s) => s.trim());
    // console.log("🚀 ~ getValueFromCondition ~ leftRaw:", leftRaw);
    if (leftRaw?.includes("[]")) {
      let right = rightRaw?.split(".")?.[0];
      let rightData = formData?.[right];
      let data = field?.[leftRaw?.split(".")?.[0]]?.filter(
        (fieldData) => fieldData?.template_name == rightData
      );
      return data?.[0];
    }

    const leftValue = resolvePathOrValue(leftRaw, formData);
    // console.log("🚀 ~ getValueFromCondition ~ leftValue:", leftValue);
    const rightValue = resolvePathOrValue(rightRaw, formData);
    // console.log("🚀 ~ getValueFromCondition ~ rightValue:", rightValue);

    if (deepEqual(leftValue, rightValue)) {
      return leftValue;
    }

    return undefined;
  }

  function resolvePathOrValue(path, data) {
    // Replace [] with [0] for default index
    const normalized = path.replace(/\[\]/g, "[0]");

    try {
      const result = normalized.split(".").reduce((obj, key) => {
        if (!obj) return undefined;
        if (key.includes("[")) {
          const [base, index] = key.split(/\[|\]/).filter(Boolean);
          return obj?.[base]?.[parseInt(index)];
        } else {
          return obj?.[key];
        }
      }, data);

      // If we found a value via path, return it
      if (result !== undefined) return result;
    } catch (e) {
      console.log("resolvePath error:", e);
    }

    // If path not resolved, try returning raw string if it's a key in formData
    return data?.[path] ?? path;
  }

  function deepEqual(a, b) {
    if (a === b) return true;

    if (typeof a !== typeof b) return false;

    if (Array.isArray(a) && Array.isArray(b)) {
      if (a.length !== b.length) return false;
      return a.every((val, i) => deepEqual(val, b[i]));
    }

    if (typeof a === "object" && a !== null && b !== null) {
      const keysA = Object.keys(a);
      const keysB = Object.keys(b);
      if (keysA.length !== keysB.length) return false;
      return keysA.every((key) => deepEqual(a[key], b[key]));
    }

    return false;
  }

  function isImage(fieldData) {
    if (typeof fieldData === "undefined") return false;
    if (
      typeof fieldData === "string" &&
      (fieldData.toLowerCase().endsWith(".png") ||
        fieldData.toLowerCase().endsWith(".ico") ||
        fieldData.toLowerCase().endsWith(".gif") ||
        fieldData.toLowerCase().endsWith(".jpeg") ||
        fieldData.toLowerCase().endsWith(".jpg") ||
        fieldData.toLowerCase().endsWith(".webp") ||
        fieldData.toLowerCase().endsWith(".svg"))
    )
      return true;
    else return false;
  }
  const arrayChunkNew = (arr, n) => {
    const tabs = [];
    let currentRow = [];
    let currentTab = null;

    for (const element of arr) {
      if (element.header && element.type === "tab") {
        /* KAD added tab Sept 6, 2025 */
        // Start a new tab
        if (currentTab) {
          currentTab.rows.push(currentRow); // Add the last row to the previous tab
          tabs.push(currentTab); // Add the completed tab
        }
        currentTab = { title: element.header || "Untitled Tab", rows: [] }; // Use label or default title
        currentRow = []; // Start a new row for the new tab
        continue; // Skip the header element itself in the row data
      }

      if (element.input_type === "none") {
        continue; // Skip "none" elements
      }

      let colspan = 1;
      if ("colspan" in element) {
        colspan = element.colspan;
      }

      currentRow.push(element);

      if (currentRow.length === n) {
        if (!currentTab) {
          currentTab = { title: "Untitled Tab", rows: [] }; // Create default tab if no headers are found
        }
        currentTab.rows.push(currentRow);
        currentRow = [];
      }
    }

    // Add the last tab and any remaining row
    if (currentTab) {
      if (currentRow.length > 0) {
        currentTab.rows.push(currentRow);
      }
      tabs.push(currentTab);
    } else if (currentRow.length > 0) {
      // Handle the case where there were no headers and we have rows
      const defaultTab = { title: "Untitled Tab", rows: [currentRow] };
      tabs.push(defaultTab);
    }

    return tabs;
  };

  const [activeTab, setActiveTab] = useState(
    props.activeTab || 0
  ); /* KAD added the props.activeTab to default to same tab in the Display Screen Feb 19, 2025 */
  const tabs = arrayChunkNew(props.config.fields, 3); // 3 elements per row
  return (
    <Container className="sec-all-text-white">
      <Row>
        <Col>
          <TopMargin />
          <div
            style={{ width: 90 + "%" }}
            className="agents-view-page-top-button"
          >
            {!props.hideBackButton && (
              <SuperAppButton
                className="primary-gradient-btn"
                onClick={handleCancel}
              >
                Back
              </SuperAppButton>
            )}
            <div
              style={{ color: "white", display: "flex", alignItems: "center" }}
            >
              Note: (*) = Required Field
            </div>
            {false && actionType === "CREATE" && (
              <h1>
                {actionType === "CREATE" ? "Create" : ""}{" "}
                {actionType === "CREATE" &&
                  convertCamelToDisplayName(
                    props.config.collection.endsWith("s")
                      ? props.config.collection.substring(
                          0,
                          // Got rid of the -1 in the substring function - 12/28/2024 Ryan
                          props.config.collection.length - 1
                        )
                      : props.config.collection
                  )}
              </h1>
            )}
          </div>
          {/* Tab Navigation */}
          {tabs.length > 1 && (
            <div className="superappobject">
              <div className="top-menu">
                <ul className="menu-lists">
                  {tabs.map((tab, index) => (
                    <li className="menu-item">
                      <button
                        key={index}
                        onClick={() => setActiveTab(index)}
                        className={activeTab === index ? "active" : ""}
                      >
                        {tab.title}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
          <RowMargin />
          <Form noValidate validated={validated}>
            {tabs.length > 0 &&
              tabs[activeTab] &&
              tabs[activeTab].rows.map((row, rowIndex) => (
                <div className="row" key={rowIndex}>
                  {" "}
                  {/* Key for each row */}
                  {/* eslint-disable-next-line array-callback-return */}
                  {row.map((field, colIndex) => {
                    //FROM ORIGINAL >>ABOVE 5 lines LEFTCURLYBRACKETprops.config.fields.mapLEFTPARENTTHESIS field => LEFTCURLYBRACKET
                    if (typeof field.conditional !== "undefined") {
                      //     conditional: "AGENT_TYPE === DIALOGFLOW",
                      if (false) {
                        const values = field.conditional.split(" ");
                        if (formData.data[values[0]] !== values[2]) return true;
                      } else {
                        /* KAD added April 8, 2025 */
                        if (!evaluateCondition(field, formData)) {
                          return true; // Or null, or whatever you want to return
                        }
                      }
                    }
                    if (typeof field.conditional1 !== "undefined") {
                      //     conditional: "AGENT_TYPE === DIALOGFLOW",
                      var variables = formData.data;
                      variables["users"] = props.userDeep;
                      variables["admins"] = [];

                      // Use adminEmails array instead of adminEmail1, 2, 3. Vik, Feb 11, 2025
                      if (
                        Array.isArray(globalContextData["data"]["adminEmails"])
                      ) {
                        variables["admins"] = [
                          ...globalContextData["data"]["adminEmails"],
                        ];
                      }

                      const result = evaluateDynamicLogic(
                        field.conditional1,
                        variables
                      );
                      if (!result) return true;
                    }
                    /* KAD added this June 27, 2025 to only show fields if you have to enter it...we were showing Agent ID before it was even populated */
                    if (field.input_type === "display") {
                      return false;
                    }
                    if (
                      "flags" in field &&
                      field.flags.indexOf("display") >= 0
                    ) {
                      return true;
                    }

                    /* for default Fields, we have to seed their data in the formData because there is no typing action to call handleInputChange */
                    if (
                      actionType === "CREATE" &&
                      field.default &&
                      field.default.length > 0
                    ) {
                      if (!(field.name in formData.data)) {
                        setFormData({
                          data: {
                            ...formData.data,
                            [field.name]: field.default,
                          },
                          status: "IDLE",
                        });
                      }
                    }

                    var attributes = {};
                    attributes["required"] = false;
                    if (field.required) attributes["required"] = true;

                    //if (validated) /* This is a catch all for ALL validations ...prints out the nice red message under the input field  */
                    //   attributes["isInvalid"] = validated && validField(formData.data[field.name], field);

                    /* Handle setting the red error color for invalid fields */
                    attributes["isInvalid"] = isInvalidField(
                      formData.data[field.name],
                      field
                    );
                    if ("header" in field) {
                      return (
                        <div
                          key={field.header}
                          style={
                            "colspan" in field && field.colspan === 3
                              ? props.style.gridStyle100
                              : props.style.gridStyle33
                          }
                        >
                          <div
                            className="common-from-sub-heading"
                            style={{ marginLeft: "13px", marginRight: "13px" }}
                          >
                            <div className="leinfo">{field.header}</div>
                          </div>
                        </div>
                      );
                    }

                    if ("instructions" in field) {
                      /* KAD added this July 31, 2025 to put in some instructions */
                      return (
                        <div className="col-12">
                          {
                            <div
                              key={field.instructions}
                              style={
                                "colspan" in field && field.colspan === 3
                                  ? props.style.gridStyle100
                                  : props.style.gridStyle33
                              }
                            >
                              <div
                                style={
                                  superAppStyle.displayCreateEditInstructions
                                }
                              >
                                <b>{field.instructions}</b>
                              </div>
                            </div>
                          }
                        </div>
                      );
                    }

                    /*Vik(Sep 9, 2025): Implemented dynamicDisplayComponent functionality to draw component using meta data */
                    if (props.dynamicDisplayComponent) {
                      let DynamicComponent = null;
                      // Check if dynamicDisplayComponent is an array
                      if (Array.isArray(props.dynamicDisplayComponent)) {
                        const componentEntry =
                          props.dynamicDisplayComponent.find(
                            (entry) => entry.name === field.name
                          );
                        DynamicComponent = componentEntry?.component;
                      } else if (props.dynamicDisplayComponent[field.name]) {
                        // Fallback for object structure (for backward compatibility)
                        DynamicComponent =
                          props.dynamicDisplayComponent[field.name];
                      }

                      if (DynamicComponent) {
                        return (
                          <div
                            key={field.name}
                            className={
                              "colspan" in field && field.colspan === 3
                                ? "col-12"
                                : "col-md-12 col-lg-4"
                            }
                          >
                            <Form.Group
                              controlId={field.name}
                              className="form-group"
                            >
                              <Form.Label style={props.style.displayName}>
                                {field.display_name}{" "}
                                {field.help && (
                                  <Tooltip placement="top" title={field.help}>
                                    <InfoIcon />
                                  </Tooltip>
                                )}{" "}
                                {field.required === true ? " (*) " : ""}
                              </Form.Label>
                              <DynamicComponent
                                quick_replies={formData.data[field.name] || []}
                                handleSaveAlljson={(data) => {
                                  setListData(field.name, data.quick_replies);
                                }}
                                {...field} // Pass additional field config
                              />
                              <Form.Control.Feedback type="invalid">
                                {field.error_message ||
                                  `Please provide valid ${field.display_name}`}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </div>
                        );
                      }
                    }

                    if (field.input_type === "empty") {
                      /* KAD added Mar 6, 2025 to put a space in the grid */
                      <div></div>;
                    }

                    if (field.input_type === "list") {
                      if (field.list_fields)
                        attributes["fields"] = field.list_fields;

                      return (
                        <div
                          key={field.name}
                          className={
                            "colspan" in field && field.colspan === 3
                              ? "col-12"
                              : "col-md-12 col-lg-4"
                          }
                        >
                          <Form.Group
                            controlId={field.name}
                            className="form-group"
                          >
                            <div key={field.name} className="form-group">
                              <Form.Label style={props.style.displayName}>
                                {field.display_name}{" "}
                                {field.help && (
                                  <Tooltip placement="top" title={field.help}>
                                    <InfoIcon />
                                  </Tooltip>
                                )}{" "}
                                {field.required === true ? " (*) " : ""}{" "}
                              </Form.Label>
                              <List
                                {...attributes}
                                list={formData.data[field.name]}
                                list_config={field.list_config}
                                list_subtable={field.list_subtable}
                                list_display_field={field.list_display_field}
                                list_max_size={field.list_max_size}
                                field_name={field.name}
                                callback={setListData}
                                regex={field.regex}
                                widgetEditor={field.widgetEditor}
                              />
                            </div>
                          </Form.Group>
                        </div>
                      );
                    }
                    if (field.input_type === "multiselect") {
                      if (field.list_fields)
                        attributes["fields"] = field.list_fields;

                      return (
                        <div
                          key={field.name}
                          className={
                            "colspan" in field && field.colspan === 3
                              ? "col-12"
                              : "col-md-12 col-lg-4"
                          }
                        >
                          <Form.Group
                            controlId={field.name}
                            className="form-group"
                          >
                            <div key={field.name} className="form-group">
                              {/* console.log("fieldfieldfield", field) */}
                              <Form.Label style={props.style.displayName}>
                                {field.display_name}{" "}
                                {field.help && (
                                  <Tooltip placement="top" title={field.help}>
                                    <InfoIcon />
                                  </Tooltip>
                                )}{" "}
                                {field.required === true ? " (*) " : ""}{" "}
                              </Form.Label>
                              <MultiSelect
                                options={field?.values}
                                title={field?.display_name}
                                onChange={(data) => {
                                  console.log("🚀 ~ data:", data);

                                  setListData(field.name, data);
                                }}
                                selectedList={formData?.data[field?.name] || []}
                              />
                            </div>
                          </Form.Group>
                        </div>
                      );
                    }
                    if (field.input_type === "textarealist") {
                      if (field.list_fields)
                        attributes["fields"] = field.list_fields;

                      return (
                        <div
                          key={field.name}
                          style={{ width: "100%" }}
                          // className="form-group"
                        >
                          <Form.Label style={props.style.displayName}>
                            {field.display_name}{" "}
                            {field.help && (
                              <Tooltip placement="top" title={field.help}>
                                <InfoIcon />
                              </Tooltip>
                            )}{" "}
                            {field.required === true ? " (*) " : ""}{" "}
                          </Form.Label>
                          <TextareaList
                            config={{ ...field, ...field?.config }}
                            title={field?.display_name}
                            targetValue={field?.targetValue}
                            value={formData?.data[field?.name]}
                            onChange={(data) => {
                              console.log("🚀 ~ TextareaListdata:", data);

                              setListData(field.name, data);
                            }}
                            setListData={setListData}
                            dataObject={formData?.data}
                            selectedList={formData?.data[field?.name] || []}
                            popupGalleryProps={{
                              userDeep: props.userDeep, // ✅ only these two
                              data: formData?.data,
                            }}
                          />
                        </div>
                      );
                    }

                    if (field.input_type === "multiHtmlContent") {
                      if (field.list_fields)
                        attributes["fields"] = field.list_fields;

                      return (
                        <div
                          key={field.name}
                          style={{ width: "100%" }}
                          // className="form-group"
                        >
                          <>
                            <Form.Label style={props.style.displayName}>
                              {field.display_name}{" "}
                              {field.help && (
                                <Tooltip placement="top" title={field.help}>
                                  <InfoIcon />
                                </Tooltip>
                              )}{" "}
                              {field.required === true ? " (*) " : ""}{" "}
                            </Form.Label>
                            <MultiHtmlContent
                              contentObject={formData?.data?.[field?.name]}
                              isDisable={false}
                              onContentChange={(htmldata) => {
                                // console.log("🚀 ~ htmldataMultiHtmlContent:", htmldata)
                                setListData(field.name, htmldata);
                              }}
                            />
                          </>
                        </div>
                      );
                    }

                    /* KAD added this Feb 22, 2025 to allow for the Integrations Editor */
                    if (field.input_type === "object") {
                      if (field.object_fields)
                        attributes["fields"] = field.object_fields;

                      if (!(field.name in formData.data)) {
                        setFormData({
                          data: {
                            ...formData.data,
                            [field.name]: field.default,
                          },
                          status: "IDLE",
                        });
                      }

                      return (
                        <div
                          key={field.name}
                          className={
                            "colspan" in field && field.colspan === 3
                              ? "col-12"
                              : "col-md-12 col-lg-4"
                          }
                        >
                          <Form.Group
                            controlId={field.name}
                            className="form-group"
                          >
                            <div key={field.name} className="form-group">
                              <Form.Label style={props.style.displayName}>
                                {field.display_name}{" "}
                                {field.help && (
                                  <Tooltip placement="top" title={field.help}>
                                    <InfoIcon />
                                  </Tooltip>
                                )}{" "}
                                {field.required === true ? " (*) " : ""}{" "}
                              </Form.Label>
                              <Object
                                {...attributes}
                                object={formData.data[field.name]}
                                object_config={field.object_config}
                                field_name={field.name}
                                callback={setListData}
                                regex={field.regex}
                              />
                            </div>
                          </Form.Group>
                        </div>
                      );
                    }
                    if (field.input_type === "checkbox") {
                      if (formData.data[field.name])
                        attributes["checked"] = true;

                      return (
                        <div
                          key={field.name}
                          className={
                            "colspan" in field && field.colspan === 3
                              ? "col-12"
                              : "col-md-12 col-lg-4"
                          }
                        >
                          <Form.Group
                            controlId={field.name}
                            className="form-group"
                          >
                            <Form.Label style={props.style.displayName}>
                              {field.display_name}{" "}
                              {field.help && (
                                <Tooltip placement="top" title={field.help}>
                                  <InfoIcon />
                                </Tooltip>
                              )}{" "}
                              {field.required === true ? " (*) " : ""}{" "}
                            </Form.Label>
                            {field.consent_text &&
                              field.consent_text.length > 0 && (
                                <div style={{ color: "red" }}>
                                  {field.consent_text}
                                </div>
                              )}
                            <Form.Control
                              {...attributes}
                              value={formData.data[field.name]}
                              type="checkbox"
                              style={superAppStyle.checkBoxAccentColor}
                              name={field.name}
                              placeholder={field.placeholder}
                              onChange={handleInputChange}
                              className="form-control"
                            ></Form.Control>
                            <Form.Control.Feedback type="invalid">
                              Click to disable
                            </Form.Control.Feedback>
                          </Form.Group>
                        </div>
                      );
                    }
                    if (field.input_type === "dynamicJsonEditorV1") {
                      return (
                        <>
                          <div
                            key={field.name}
                            className={
                              "colspan" in field && field.colspan === 3
                                ? "col-12"
                                : "col-md-12 col-lg-4"
                            }
                          >
                            <Form.Group
                              controlId={field.name}
                              className="form-group"
                            >
                              <Form.Label style={props.style.displayName}>
                                {field.display_name}{" "}
                                {field.help && (
                                  <Tooltip placement="top" title={field.help}>
                                    <InfoIcon />
                                  </Tooltip>
                                )}{" "}
                                {field.required === true ? " (*) " : ""}{" "}
                              </Form.Label>
                              {/* <DynamicJsonEditorV1
                                default_json={
                                  formData?.data?.[field.name] ||
                                  field?.default_json
                                }
                                default_options={field?.default_options}
                                default_path={field?.default_path}
                                setListData={(data) =>
                                  setListData(field?.name, data)
                                }
                                customTooltip={field?.customTooltip}
                                formData={formData?.data}
                                fieldData={field}
                                sample_templates={field?.sample_templates}
                              /> */}

                              <IntegrationEditorConfig
                                initialJsons={
                                  formData?.data?.[field.name] ||
                                  field?.default_json
                                }
                                setFormData={setFormData}
                                formData={formData}
                                field={field}
                                setListData={setListData}
                              />
                            </Form.Group>
                          </div>
                        </>
                      );
                    }

                    if (field.input_type === "date") {
                      /* Handle default fields */
                      if (
                        (actionType === "CREATE" || actionType === "EDIT") &&
                        field.default &&
                        field.default.length > 0
                      ) {
                        if (!(field.name in formData.data)) {
                          setFormData({
                            data: {
                              ...formData.data,
                              [field.name]: field.default,
                            },
                            status: "IDLE",
                          });
                        }
                      }
                      //defaultValue={field.default}
                      return (
                        <div
                          key={field.name}
                          className={
                            "colspan" in field && field.colspan === 3
                              ? "col-12"
                              : "col-md-12 col-lg-4"
                          }
                        >
                          <Form.Group
                            controlId={field.name}
                            className="form-group"
                          >
                            <Form.Label style={props.style.displayName}>
                              {field.display_name}{" "}
                              {field.help && (
                                <Tooltip placement="top" title={field.help}>
                                  <InfoIcon />
                                </Tooltip>
                              )}{" "}
                              {field.required === true ? " (*) " : ""}{" "}
                            </Form.Label>
                            <Form.Control
                              {...attributes}
                              value={formData.data[field.name]}
                              type="date"
                              name={field.name}
                              title={field.placeholder}
                              onChange={handleInputChange}
                              className="form-control"
                            ></Form.Control>
                            <Form.Control.Feedback type="invalid">
                              Please provide a valid {field.display_name}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </div>
                      );
                    }
                    if (field.input_type === "color") {
                      /* Handle default fields */
                      if (
                        (actionType === "CREATE" || actionType === "EDIT") &&
                        field.default &&
                        field.default.length > 0
                      ) {
                        if (!(field.name in formData.data)) {
                          setFormData({
                            data: {
                              ...formData.data,
                              [field.name]: field.default,
                            },
                            status: "IDLE",
                          });
                        }
                      }
                      //defaultValue={field.default}
                      return (
                        <div
                          key={field.name}
                          className={
                            "colspan" in field && field.colspan === 3
                              ? "col-12"
                              : "col-md-12 col-lg-4"
                          }
                        >
                          <Form.Group
                            controlId={field.name}
                            className="form-group"
                          >
                            <Form.Label style={props.style.displayName}>
                              {field.display_name}{" "}
                              {field.help && (
                                <Tooltip placement="top" title={field.help}>
                                  <InfoIcon />
                                </Tooltip>
                              )}{" "}
                              {field.required === true ? " (*) " : ""}{" "}
                            </Form.Label>
                            <Form.Control
                              {...attributes}
                              value={formData.data[field.name]}
                              type="color"
                              name={field.name}
                              title={field.placeholder}
                              onChange={handleInputChange}
                              className="form-control"
                              isInvalid={
                                validated &&
                                isInvalidColor(formData.data[field.name])
                              }
                            ></Form.Control>
                            <Form.Control.Feedback type="invalid">
                              Please provide a valid {field.display_name}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </div>
                      );
                    }
                    if (field.input_type === "text") {
                      //var textValue = "";
                      if (actionType === "EDIT")
                        if (!("readonly" in field))
                          //textValue = formData.data[field.name];

                          /* don't OVERWRITE an existing readonly setting in the config */
                          field["readonly"] = false;

                      /* Handle default fields */
                      if (
                        (actionType === "CREATE" || actionType === "EDIT") &&
                        field.default &&
                        field.default.length > 0
                      ) {
                        // textValue = field.default;
                        field["readonly"] = true;
                        if (
                          field.default.trim() === "{USER}" &&
                          "user" in props
                        )
                          field.default = props.user;
                        if (
                          field.default.trim() === "{ID}" &&
                          "remote_id" in props
                        )
                          field.default = props.remote_id;

                        if (!(field.name in formData.data)) {
                          setFormData({
                            data: {
                              ...formData.data,
                              [field.name]: field.default,
                            },
                            status: "IDLE",
                          });
                        }
                      }
                      return (
                        <div
                          key={field.name}
                          className={
                            "colspan" in field && field.colspan === 3
                              ? "col-12"
                              : "col-md-12 col-lg-4"
                          }
                        >
                          <Form.Group
                            controlId={field.name}
                            className="form-group"
                          >
                            <div className="label-with-right-add-btn">
                              <Form.Label style={props.style.displayName}>
                                <div>
                                  {field.display_name}{" "}
                                  {field.help && (
                                    <Tooltip placement="top" title={field.help}>
                                      <InfoIcon />
                                    </Tooltip>
                                  )}{" "}
                                  {field.required === true ? " (*) " : ""}{" "}
                                  {field.input_type === "color" && (
                                    <PopoverPicker
                                      color={formData.data[field.name]}
                                      onChange={(e) =>
                                        onColorChange(e, field.name)
                                      }
                                    />
                                  )}
                                </div>
                                {/* {field.samples && (
                                  <>
                                    {" "}
                                    <DrawMenu
                                      field={field}
                                      data={formData.data}
                                      setFormData={setFormData}
                                    />{" "}
                                  </>
                                )} */}
                                {field.samples && (
                                  <>
                                    {" "}
                                    <DrawMenu
                                      field={field}
                                      data={formData.data}
                                      setFormData={setFormData}
                                      iconData={
                                        formData?.data?.agent_icon_configuration
                                      }
                                    />{" "}
                                  </>
                                )}
                                {field.image_picker && (
                                  <>
                                    {" "}
                                    <PopupGallery
                                      userDeep={props.userDeep}
                                      setFormData={setFormData}
                                      data={formData.data}
                                      field={field}
                                    />{" "}
                                  </>
                                )}
                              </Form.Label>
                            </div>

                            <Form.Control
                              {...attributes}
                              readOnly={field["readonly"]}
                              value={formData.data[field.name]}
                              type="text"
                              name={field.name}
                              className="form-control"
                              placeholder={field.placeholder}
                              onChange={handleInputChange}
                            ></Form.Control>

                            <Form.Control.Feedback type="invalid">
                              {field.error_message && field.error_message}
                              {!field.error_message && (
                                <>
                                  Please enter valid {field.display_name} field
                                </>
                              )}
                            </Form.Control.Feedback>
                          </Form.Group>
                          {(isImage(formData.data[field.name]) ||
                            field?.sample_type) && (
                            <>
                              {/* KAD added complex logic above on Sept 6, 2025 to make image bigger after selection, also the spacer in there */}
                              <SecureImage
                                url={formData.data[field.name]}
                                imageData={
                                  formData?.data?.agent_icon_configuration
                                    ? formData.data.agent_icon_configuration
                                    : field.image_width
                                    ? { width: field.image_width }
                                    : null
                                }
                              />
                              <div style={{ paddingBottom: "20px" }}></div>
                            </>
                          )}
                        </div>
                      );
                    }
                    if (field.input_type === "dropdown") {
                      var optionsToDisplay = [];
                      /* Single value array */
                      if (
                        Array.isArray(field.values) &&
                        typeof field.values_display_names === "undefined"
                      ) {
                        /* just an array of strings..do nothing */
                        optionsToDisplay = optionsToDisplay.concat(
                          field.values
                        );
                      } /* Single value array, with Display Value array */ else if (
                        Array.isArray(field.values) &&
                        Array.isArray(field.values_display_names)
                      ) {
                        for (let x = 0; x < field.values.length; x++) {
                          const newObject = {};
                          newObject[field.values[x]] =
                            field.values_display_names[x];
                          optionsToDisplay.push(newObject);
                          //console.log(JSON.stringify(optionsToDisplay));
                        }
                      } else if (field.values === "myObjects") {
                        /* Pull a list of all Agents..doesn't work for any object type but should TODO */
                        /* this is for like the nextAgent code ...need to generalize this */
                        //const myObjects = props.allObjects;
                        const myObjects = [
                          ...props.allObjects,
                        ]; /* KAD did this April 23, 2025 because myObjects was just growing and growing */

                        /* KAD added Jan 20, 2025 */
                        const defaultNextAgents =
                          globalContextData["data"]["defaultNextAgents"];
                        if (defaultNextAgents) {
                          for (let x = 0; x < defaultNextAgents.length; x++) {
                            if (
                              !defaultNextAgents[x]["agentName"].includes(
                                "(DEFAULT)"
                              )
                            )
                              defaultNextAgents[x]["agentName"] =
                                defaultNextAgents[x]["agentName"] +
                                " (DEFAULT)";
                            myObjects.push(defaultNextAgents[x]);
                          }
                          //console.log("KEVIN " + JSON.stringify(myObjects));
                        }
                        //field.values = [];
                        /* TODO: Can't have hardcoded stuff in SuperAppObject */
                        for (let x = 0; x < myObjects.length; x++) {
                          /* don't add this Agent into the list, just want OTHER agents */ //field.values.push(myObjects[x]);
                          if (
                            myObjects[x]["id"] !== formData.data["id"] &&
                            (myObjects[x]["agentType"] === "DOCUMENT_QA" ||
                              myObjects[x]["agentType"] === "WEBSITE_QA" ||
                              myObjects[x]["agentType"] ===
                                "COMBINATION_AGENT" ||
                              myObjects[x]["agentType"] ===
                                "WEBHOOK") /* KAD added WEBHOOK  Jan 20, 2025 */
                          ) {
                            optionsToDisplay.push(myObjects[x]);
                          }
                        }
                      } else if (field.values === "agents") {
                        /* NEW VERSION KAD Jan 18, 2025 to handle ANY table lookup...will evolve over time */

                        const myObjects = props.allObjects;
                        /* TODO: Can't have hardcoded stuff in SuperAppObject */
                        for (let x = 0; x < myObjects.length; x++) {
                          optionsToDisplay.push(myObjects[x]);
                          myObjectsLookup[myObjects[x]["id"]] = myObjects[x];
                        }
                        //setMyObjectsLookup(myObjectsLookup);
                      } else {
                        /* TODO: Need to add the adminConfig search term..it's not a fall through */
                        const values = field.values.split(".");
                        if (values[0] === "adminConfig") {
                          const agentTypes =
                            globalContextData["data"]["agentTypes"];
                          //field.values = [];
                          for (let x = 0; x < agentTypes.length || 0; x++) {
                            const displayRule = agentTypes[x]["displayRule"];
                            //const agentType = agentTypes[x]["agentType"];
                            var showValue = true;
                            if (
                              typeof displayRule !== "undefined" &&
                              displayRule.length > 0
                            ) {
                              showValue = evaluateDisplayDropdownRule(
                                displayRule,
                                props.userDeep
                              );
                            }
                            if (showValue) {
                              //field.values.push(agentTypes[x]["agentType"]);
                              //field.values.push(agentTypes[x]); /* KAD moved to an object Nov 4, 2024 so we can apply a template */
                              optionsToDisplay.push(
                                agentTypes[x]
                              ); /* KAD moved to an object Nov 4, 2024 so we can apply a template */
                            }
                          }
                        }
                      }

                      return (
                        <div
                          key={field.name}
                          className={
                            "colspan" in field && field.colspan === 3
                              ? "col-12"
                              : "col-md-12 col-lg-4"
                          }
                        >
                          <Form.Group
                            controlId={field.name}
                            className="form-group"
                          >
                            <Form.Label style={props.style.displayName}>
                              {field.display_name}{" "}
                              {field.help && (
                                <Tooltip placement="top" title={field.help}>
                                  <InfoIcon />
                                </Tooltip>
                              )}{" "}
                              {field.required === true ? " (*) " : ""}{" "}
                            </Form.Label>
                            <Form.Control
                              {...attributes}
                              value={formData.data[field.name] || field.default}
                              as="select"
                              type="select"
                              className="form-control"
                              name={field.name}
                              onChange={handleInputChange}
                              defaultValue={field.dafault}
                            >
                              <option></option>
                              <Options
                                config={field}
                                options={optionsToDisplay}
                              />
                            </Form.Control>
                            <Form.Control.Feedback type="invalid">
                              Please select a {field.display_name}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </div>
                      );
                    }
                    if (field.input_type === "subTable") {
                      return (
                        <div
                          key={field.name}
                          className={
                            "colspan" in field && field.colspan === 3
                              ? "col-12"
                              : "col-md-12 col-lg-4"
                          }
                        ></div>
                      );
                    }
                    if (field.input_type === "html") {
                      return (
                        <div
                          key={field.name}
                          className={
                            "colspan" in field && field.colspan === 3
                              ? "col-12"
                              : "col-md-12 col-lg-4"
                          }
                        >
                          <Form.Group
                            controlId={field.name}
                            className="form-group"
                          >
                            <Form.Label style={props.style.displayName}>
                              {field.display_name}{" "}
                              {field.help && (
                                <Tooltip placement="top" title={field.help}>
                                  <InfoIcon />
                                </Tooltip>
                              )}{" "}
                              {field.required === true ? " (*) " : ""}{" "}
                            </Form.Label>
                            <Editor
                              value={formData.data[field.name]}
                              onChange={(e) => onHTMLChange(e, field.name)}
                            />
                          </Form.Group>
                        </div>
                      );
                    }
                    if (field.input_type === "textarea") {
                      return (
                        <div
                          key={field.name}
                          className={
                            "colspan" in field && field.colspan === 3
                              ? "col-12"
                              : "col-md-12 col-lg-4"
                          }
                        >
                          <Form.Group
                            controlId={field.name}
                            className="form-group"
                          >
                            <Box className="label-with-right-add-btn">
                              <Form.Label style={props.style.displayName}>
                                {field.display_name}{" "}
                                {field.help && (
                                  <Tooltip placement="top" title={field.help}>
                                    <InfoIcon sx={{ marginLeft: "5px" }} />
                                  </Tooltip>
                                )}{" "}
                                {field.required === true ? " (*) " : ""}{" "}
                              </Form.Label>
                              {field.samples && (
                                <>
                                  {" "}
                                  <DrawMenu
                                    field={field}
                                    data={formData.data}
                                    setFormData={setFormData}
                                  />{" "}
                                </>
                              )}
                            </Box>
                            <Form.Control
                              as="textarea"
                              rows={field.text_area_num_rows || 3}
                              {...attributes}
                              className="form-control"
                              value={formData.data[field.name]}
                              name={field.name}
                              type="textarea"
                              placeholder={field.placeholder}
                              onChange={handleInputChange}
                            ></Form.Control>
                            <Form.Control.Feedback type="invalid">
                              {field.error_message && field.error_message}
                              {!field.error_message && (
                                <>
                                  Please enter valid {field.display_name} field
                                </>
                              )}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </div>
                      );
                    }
                    if (field.input_type === "image") {
                      return <UploadFile />;
                    }
                    if (field.input_type === "display") {
                      return (
                        <>
                          {!field.preventEdit ? (
                            <div
                              key={field.name}
                              className={
                                "colspan" in field && field.colspan === 3
                                  ? "col-12"
                                  : "col-md-12 col-lg-4"
                              }
                            >
                              <Form.Group
                                controlId={field.name}
                                className="form-group"
                              >
                                <Form.Label style={props.style.displayName}>
                                  {field.display_name}{" "}
                                  {field.help && (
                                    <Tooltip placement="top" title={field.help}>
                                      <InfoIcon />
                                    </Tooltip>
                                  )}{" "}
                                  {field.required === true ? " (*) " : ""}{" "}
                                </Form.Label>
                                <p style={props.style.displayValue}>
                                  {formData.data[field.name]
                                    ? formData.data[field.name]
                                    : "TBD"}
                                </p>
                              </Form.Group>
                            </div>
                          ) : (
                            <></>
                          )}
                        </>
                      );
                    }
                    if (field.input_type === "mcp_client") {
                      return <MCPClientUI></MCPClientUI>;
                    }
                    if (field.input_type === "none") {
                      return <div>{field.placeholder} </div>;
                    }
                  })}
                </div>
              ))}
          </Form>
          {/* KAD added this change to handle Submit for the Config Editor Feb 10, 2025 */}
          <div className="form-submit-action">
            <SuperAppButton
              className="primary-gradient-btn"
              type="button"
              onClick={
                props.dontPersistData
                  ? handleSubmitWithoutPersist
                  : handleSubmit
              }
            >
              {props.config.buttonName}
            </SuperAppButton>
            &nbsp;
            <SuperAppButton
              className="transparent-bg-white-btn"
              type="button"
              onClick={handleCancel}
            >
              Cancel
            </SuperAppButton>
            &nbsp;
            {actionType === "EDIT" &&
              canDeleteRow(props, props.config, formData.data) && (
                <SuperAppButton
                  className="transparent-bg-white-btn"
                  type="button"
                  onClick={props.handleDelete}
                >
                  Delete
                </SuperAppButton>
              )}
          </div>
        </Col>
      </Row>
      {formData.status === "SUBMITTED" && (
        <React.Fragment>
          <RowMargin />
          <Row>
            <Col>
              <Loading />
            </Col>
          </Row>
        </React.Fragment>
      )}
      {formData.status === "ERROR" && (
        <React.Fragment>
          <RowMargin />
          <Row>
            <Col>
              <Alert variant="danger">
                Failed to add/update record, please try again later.
              </Alert>
            </Col>
          </Row>
        </React.Fragment>
      )}
      {formData.status === "VALIDATION_FAILURE" && (
        <React.Fragment>
          <RowMargin />
          <Row>
            <Col>
              <Alert variant="danger">
                Failed to add/update record {validationString}
              </Alert>
            </Col>
          </Row>
        </React.Fragment>
      )}
      {formData.status === "SUCCESS" && (
        <React.Fragment>
          <RowMargin />
          <Row>
            <Col>
              <Alert variant="success">Successfully added!</Alert>
            </Col>
          </Row>
        </React.Fragment>
      )}
    </Container>
  );
}
